module.exports = __webpack_public_path__ + "img/edit_extra_users.12987c74.svg";